module.exports = __webpack_public_path__ + "static/media/orderlist.a50fd6c3.svg";